/**
 * 追従カートバー
 *
 * スクロールでカートボタンが画面外になったら表示、見えたら非表示。
 * 下スクロール時のみ表示し、上スクロール時は非表示にする。
 * バリエーション・数量は商品ページ本体と双方向同期する。
 */
(function () {
  'use strict';

  const sticky_cart = document.getElementById('cm-sticky-cart');
  if (!sticky_cart) return;

  const section_id = sticky_cart.dataset.sectionId;
  const purchase_limit = parseInt(sticky_cart.dataset.purchaseLimit, 10) || 0;
  const product_id = parseInt(sticky_cart.dataset.productId, 10) || 0;

  // --- DOM要素のキャッシュ ---
  const qty_input = sticky_cart.querySelector('.cm-sticky-cart__quantity-input');
  const add_to_cart_btn = sticky_cart.querySelector('.cm-sticky-cart__add-to-cart');
  const minus_btn = sticky_cart.querySelector('[data-action="minus"]');
  const plus_btn = sticky_cart.querySelector('[data-action="plus"]');
  // ドロップダウン要素（複数オプション対応）
  const variant_dropdowns = sticky_cart.querySelectorAll('.cm-variant-dropdown');

  // --- スクロール制御変数 ---
  let last_scroll_y = window.scrollY;
  let is_buy_button_visible = true;
  let is_scrolling_down = true;
  let ticking = false;

  // 表示状態を初期化
  sticky_cart.style.display = '';

  /**
   * カートボタンの可視判定（IntersectionObserver）
   */
  function setupIntersectionObserver() {
    const buy_button_el = document.querySelector('product-form button[type="submit"]');
    if (!buy_button_el) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        is_buy_button_visible = entry.isIntersecting;
        updateVisibility();
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observer.observe(buy_button_el);
  }

  /**
   * スクロール方向の検出
   */
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(function () {
        const current_scroll_y = window.scrollY;
        is_scrolling_down = current_scroll_y > last_scroll_y;
        last_scroll_y = current_scroll_y;
        updateVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }

  /**
   * 表示/非表示の更新
   * ページ最下部到達時は非表示にする
   */
  function updateVisibility() {
    const at_bottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 50);
    const should_show = !is_buy_button_visible && is_scrolling_down && !at_bottom;
    if (should_show) {
      sticky_cart.classList.add('cm-sticky-cart--visible');
      sticky_cart.setAttribute('aria-hidden', 'false');
      sticky_cart.removeAttribute('inert');
    } else {
      sticky_cart.classList.remove('cm-sticky-cart--visible');
      sticky_cart.setAttribute('aria-hidden', 'true');
      sticky_cart.setAttribute('inert', '');
    }
  }

  // =============================================
  // 数量ピッカー
  // =============================================

  function setupQuantityButtons() {
    if (!minus_btn || !plus_btn || !qty_input) return;

    minus_btn.addEventListener('click', function () {
      const current = parseInt(qty_input.value, 10);
      const min_val = parseInt(qty_input.min, 10) || 1;
      const step = parseInt(qty_input.step, 10) || 1;
      if (current - step >= min_val) {
        qty_input.value = current - step;
        syncToMainQuantity();
      }
    });

    plus_btn.addEventListener('click', function () {
      const current = parseInt(qty_input.value, 10);
      const max_val = qty_input.max ? parseInt(qty_input.max, 10) : Infinity;
      const step = parseInt(qty_input.step, 10) || 1;
      if (current + step <= max_val) {
        qty_input.value = current + step;
        syncToMainQuantity();
      }
    });

    qty_input.addEventListener('change', function () {
      syncToMainQuantity();
    });
  }

  /** 追従カート → 本体 数量同期 */
  function syncToMainQuantity() {
    const main_qty_input = document.getElementById('Quantity-' + section_id);
    if (main_qty_input) {
      main_qty_input.value = qty_input.value;
      main_qty_input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /** 本体 → 追従カート 数量同期 */
  function syncFromMainQuantity() {
    const main_qty_input = document.getElementById('Quantity-' + section_id);
    if (main_qty_input && qty_input) {
      qty_input.value = main_qty_input.value;
    }
  }

  function setupMainQuantitySync() {
    const main_qty_input = document.getElementById('Quantity-' + section_id);
    if (!main_qty_input) return;

    const observer = new MutationObserver(function () {
      syncFromMainQuantity();
    });
    observer.observe(main_qty_input, { attributes: true, attributeFilter: ['value'] });
    main_qty_input.addEventListener('change', syncFromMainQuantity);
  }

  // =============================================
  // カートに追加ボタン
  // =============================================

  function setupAddToCart() {
    if (!add_to_cart_btn) return;

    add_to_cart_btn.addEventListener('click', function () {
      if (add_to_cart_btn.disabled) return;

      // 本体の数量を同期してからフォームを送信
      syncToMainQuantity();

      setTimeout(function () {
        const main_submit = document.querySelector('product-form button[type="submit"]');
        if (main_submit && main_submit.getAttribute('aria-disabled') !== 'true' && !main_submit.disabled) {
          main_submit.click();
        }
      }, 50);
    });
  }

  // =============================================
  // バリエーションドロップダウン同期
  // =============================================

  /**
   * 追従カートのドロップダウンから本体のバリアントピッカーに同期
   */
  function setupVariantDropdownSync() {
    if (!variant_dropdowns.length) return;

    variant_dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('cm-variant-dropdown:change', function (event) {
        const detail = event.detail;
        const selected_value = detail.value;

        // 本体のカラーバリエーションピッカーのラジオボタンを探して選択
        const main_radios = document.querySelectorAll(
          '.cm-color-variant-picker__fieldset input[type="radio"]'
        );
        let found_in_color_picker = false;
        main_radios.forEach(function (radio) {
          if (radio.value === selected_value) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            found_in_color_picker = true;
          }
        });

        // 標準のvariant-selectsの非表示fieldsetも更新
        const main_variant_selects = document.querySelector('variant-selects');
        if (main_variant_selects) {
          const fieldsets = main_variant_selects.querySelectorAll('fieldset');
          fieldsets.forEach(function (fieldset) {
            const radios = fieldset.querySelectorAll('input[type="radio"]');
            radios.forEach(function (radio) {
              if (radio.value === selected_value) {
                radio.checked = true;
                if (!found_in_color_picker) {
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          });
        }
      });
    });
  }

  /**
   * product_idベースでカート内の同一商品数量を集計
   * @param {Array} cart_items カートアイテム配列
   * @returns {number} カート内合計数量
   */
  function getCartQuantityForProduct(cart_items) {
    let cart_qty = 0;
    if (!product_id) return cart_qty;
    cart_items.forEach(function (item) {
      if (item.product_id === product_id) {
        cart_qty += item.quantity;
      }
    });
    return cart_qty;
  }

  /**
   * カート更新時に購入制限を反映する
   * @param {Array} cart_items カートアイテム配列
   */
  function applyPurchaseLimit(cart_items) {
    if (purchase_limit <= 0) return;

    const cart_qty = getCartQuantityForProduct(cart_items);
    const remaining = Math.max(0, purchase_limit - cart_qty);

    const min_val = parseInt(qty_input.min, 10) || 1;
    const effective_max = Math.max(remaining, min_val);

    if (qty_input) {
      qty_input.max = effective_max;
      if (remaining > 0) {
        if (parseInt(qty_input.value, 10) > remaining) {
          qty_input.value = min_val;
        }
      } else {
        // 購入上限到達: maxはmin_valを維持し、ボタンdisabledで制御
        qty_input.value = min_val;
      }
    }

    if (add_to_cart_btn) {
      if (remaining <= 0) {
        add_to_cart_btn.disabled = true;
      } else {
        // 選択中バリアントの在庫チェック
        let is_available = true;
        if (variant_dropdowns.length > 0) {
          const selected_item = variant_dropdowns[0].querySelector('.cm-variant-dropdown__item--selected');
          if (selected_item) {
            is_available = selected_item.dataset.available === 'true';
          }
        }
        add_to_cart_btn.disabled = !is_available;
      }
    }
  }

  /**
   * PubSubイベントで本体→追従カートへのバリエーション同期
   */
  function setupVariantSync() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data) return;
      const variant = event.data.variant;
      if (!variant) return;

      // ボタンのvariant IDを更新
      if (add_to_cart_btn) {
        add_to_cart_btn.dataset.variantId = variant.id;

        if (variant.available) {
          add_to_cart_btn.disabled = false;
          add_to_cart_btn.textContent = window.variantStrings?.addToCart || 'カートに追加する';
        } else {
          add_to_cart_btn.disabled = true;
          add_to_cart_btn.textContent = window.variantStrings?.soldOut || '売り切れ';
        }
      }

      // 追従カートのドロップダウンの選択値を更新
      if (variant_dropdowns.length > 0 && window.CmVariantDropdown) {
        variant.options.forEach(function (opt_value, idx) {
          if (variant_dropdowns[idx]) {
            window.CmVariantDropdown.setValue(variant_dropdowns[idx], opt_value);
          }
        });
      }
    });

    // カート更新時に数量制限を再適用
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (purchase_limit <= 0) return;

      if (event && event.cartData && event.cartData.items) {
        applyPurchaseLimit(event.cartData.items);
      } else {
        fetch('/cart.js', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            applyPurchaseLimit(cart.items || []);
          })
          .catch(function (err) {
            console.error('追従カート: カートデータ取得エラー', err);
          });
      }
    });
  }

  // --- 初期化 ---
  setupIntersectionObserver();
  window.addEventListener('scroll', handleScroll, { passive: true });
  setupQuantityButtons();
  setupMainQuantitySync();
  setupAddToCart();
  setupVariantDropdownSync();
  setupVariantSync();
})();
